module.exports = __webpack_public_path__ + "static/img/huashobg6.0bec9f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/huashobg6.jpg
// module id = 2gnI
// module chunks = 2